import React from 'react';
import { isMobile } from 'react-device-detect';
import backgroundImage from 'assets/chat_sign_up_BG.webp';
import backgroundImageMobile from 'assets/chat_sign_up_mobile_BG.webp';
import { ChatSignUpBlock } from 'services/api/chatsApi';
import styled from 'styled-components';

interface SignUpBlockSectionProps {
  signUpBlock: ChatSignUpBlock;
  onOpenAuthModal: () => void;
}

const SignUpBlockSection: React.FC<SignUpBlockSectionProps> = ({ signUpBlock, onOpenAuthModal }) => {
  if (isMobile) {
    return (
      <MobileSignUpBlockContainer>
        <MobileContentWrapper>
          <SignUpBlockTitle>{signUpBlock.title}</SignUpBlockTitle>
          <SignUpBlockDescription>{signUpBlock.description}</SignUpBlockDescription>
          <CTAButton onClick={onOpenAuthModal}>Create Account</CTAButton>
        </MobileContentWrapper>
      </MobileSignUpBlockContainer>
    );
  }

  return (
    <SignUpBlockContainer>
      <ContentWrapper>
        <SignUpBlockTitle>{signUpBlock.title}</SignUpBlockTitle>
        <SignUpBlockDescription>{signUpBlock.description}</SignUpBlockDescription>
        <CTAButton onClick={onOpenAuthModal}>Create Account</CTAButton>
      </ContentWrapper>
    </SignUpBlockContainer>
  );
};

const SignUpBlockContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 32px;
  max-height: 252px;
  background-image: 
    linear-gradient(90deg, rgba(98, 0, 234, 0.4) 0%, rgba(236, 64, 122, 0.2) 100%),
    url(${backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 24px;
  border: 1px solid #9E5EEE;
  position: relative;
  margin-bottom: 48px;
`;

const MobileSignUpBlockContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 232px;
  background-image: 
    linear-gradient(90deg, rgba(98, 0, 234, 0.4) 0%, rgba(236, 64, 122, 0.2) 100%),
    url(${backgroundImageMobile});
  background-size: auto 100%;
  background-position: right center;
  background-repeat: no-repeat;
  border-radius: 24px;
  border: 1px solid #9E5EEE;
  position: relative;
  margin: 0 16px 48px 16px;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 60%;
`;

const MobileContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  text-align: left;
  width: 100%;
`;

const SignUpBlockTitle = styled.h2`
  color: #FFF;
  text-shadow: 0px 4px 20px #C65DE9;
  font-family: Raleway;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: 140%;
  margin: 0;
  
  @media (max-width: 720px) {
    font-size: 32px;
  }
`;

const SignUpBlockDescription = styled.p`
  color: #FFF;
  font-family: "Nunito Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
  
  @media (max-width: 720px) {
    font-size: 18px;
    line-height: 22px;
  }
`;

const CTAButton = styled.button`
  background: #C65DE9;
  border: none;
  border-radius: 50px;
  padding: 12px 24px;
  color: #FFF;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
  margin-top: 8px;
  
  @media (max-width: 720px) {
    width: fit-content;
    padding: 12px 24px;
  }
  
  &:hover {
    background: #B34DD6;
    transform: translateY(-2px);
  }
  
  transition: all 0.3s ease;
`;

export default SignUpBlockSection; 